module.exports = __webpack_public_path__ + "static/img/9b.67bad36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9b.jpg
// module id = DAja
// module chunks = 1